import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as DeleteIcon } from "../../../common/icons/delete.svg";
import { ReactComponent as DuplicateIcon } from "../../../common/icons/duplicate.svg";

type Props = {
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  rowId: string;
  isRowEditable: boolean;
  onAddFreeText: () => void;
  onDeleteRow: (id: string) => void;
  onCopyRow: (id: string) => void;
};

export const InvoiceRowActionsMenu = ({
  open,
  anchorEl,
  onClose,
  rowId,
  isRowEditable,
  onAddFreeText,
  onDeleteRow,
  onCopyRow,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <List dense disablePadding>
        <ListItem disablePadding>
          <ListItemButton
            sx={{ paddingLeft: "10px", paddingRight: "13px" }}
            disabled={!isRowEditable}
            onClick={() => {
              onAddFreeText();
              onClose();
            }}
          >
            <ListItemIcon sx={{ minWidth: "13px", marginRight: "8px" }}>
              <AddIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography>{t("freeText", { ns: "invoices" })}</Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{ paddingLeft: "13px", paddingRight: "13px" }}
            onClick={() => {
              onCopyRow(rowId);
              onClose();
            }}
          >
            <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
              <DuplicateIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography>{t("duplicate")}</Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{ paddingLeft: "13px", paddingRight: "13px" }}
            disabled={!isRowEditable}
            onClick={() => {
              onDeleteRow(rowId);
              onClose();
            }}
          >
            <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ color: "#C50631" }}>{t("delete")}</Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Menu>
  );
};
